import axios from 'axios';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import Select from 'react-select';
import Swal from 'sweetalert2';
import enteFunciones from '../function/ente.Funcion';
import senaFunciones from '../function/sena.Funciones';


const RegistrarMatriculas = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [anioLectivo, setAnioLectivo] = useState('');
  const [fichaGrupo, setFichaGrupo] = useState('');
  const [grupos, setGrupos] = useState([]);
  const [grupoSeleccionado, setGrupoSeleccionado] = useState('');
  const [coddaneEnteconformador, setCoddaneEnteconformador] = useState('');
  const [entes, setEntes] = useState([]);

  const [detallesMatricula, setDetallesMatricula] = useState([]);

  const [edit, setEdit] = useState(false);

  const opcionesEntes = entes.map((ente) => ({
    value: ente.coddaneEnteconformador,
    label: ente.nombreEnteconformador
  }));

  const opcionesGrupos = grupos.map((grupo) => ({
    value: grupo.fichaGrupo,
    label: grupo.fichaGrupo
  }));


  useEffect(() => {
    setEdit(!!id);
  }, [id]);

  useEffect(() => {
    const fetchMatricula = async () => {
      try {
        const response = await axios.get(`/api/matriculas/listid/${id}`);
        const data = response.data;

        if (data.ok && data.matricula) {
          const matricula = data.matricula;

          setFichaGrupo(matricula.fichaGrupo || '');
          setAnioLectivo(matricula.anioLectivo || '');
          setCoddaneEnteconformador(matricula.coddaneEnteconformador || '');
          setGrupoSeleccionado(matricula.fichaGrupo || '');
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'No se encontró la matrícula.',
          });
        }

      } catch (error) {
        console.error('Error al cargar matrícula por ID:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar la matrícula con el ID proporcionado.',
        });
      }
    };

    if (id) {
      fetchMatricula();
    }
  }, [id]);

  useEffect(() => {
    const fetchDetalles = async () => {
      try {
        const response = await axios.get(`/api/detallematricula/listbyid/${id}`);
        const data = response.data;

        if (data.ok && data.detalles) {
          // Formatear los datos para agregar nombre completo
          const detallesFormateados = data.detalles.map(detalle => {
            const aprendiz = detalle.aprendizObjectId;
            const nombreCompleto = `${aprendiz.nombre1Aprendiz} ${aprendiz.nombre2Aprendiz || ''} ${aprendiz.apellido1Aprendiz} ${aprendiz.apellido2Aprendiz || ''}`
              .trim()
              .replace(/\s+/g, ' ');

            return {
              ...detalle,
              nombreAprendiz: nombreCompleto
            };
          });

          setDetallesMatricula(detallesFormateados);
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'No se encontraron detalles para esta matrícula.',
          });
          setDetallesMatricula([]);
        }
      } catch (error) {
        console.error('Error al cargar detalles de matrícula:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los detalles de la matrícula.',
        });
      }
    };

    if (id) {
      fetchDetalles();
    }
  }, [id]);

  const cleanData = () => {
    setAnioLectivo('');
    setFichaGrupo('');
    setGrupoSeleccionado('');
    setCoddaneEnteconformador('');
    setDetallesMatricula([]);
    setEdit(false);
  };

  // Maneja cambios en los inputs/select de cada detalle
  const handleChange = (index, field, value) => {
    setDetallesMatricula((prevDetalles) => {
      const nuevosDetalles = [...prevDetalles];
      nuevosDetalles[index] = { ...nuevosDetalles[index], [field]: value };
      return nuevosDetalles;
    });
  };

  // Elimina un detalle del array
  const removeDetalle = (index) => {
    setDetallesMatricula((prevDetalles) => prevDetalles.filter((_, i) => i !== index));
  };

  const addDetalle = () => {
    setDetallesMatricula([...detallesMatricula, { documentoAprendiz: '', estadoMatricula: '', tipoMatricula: '' }]);
  };


  const saveMatricula = async () => {
    if (!fichaGrupo || !anioLectivo || !coddaneEnteconformador || detallesMatricula.length === 0) {
      return Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Por favor completa todos los campos y agrega al menos un aprendiz.',
      });
    }

    const newMatricula = {
      fichaGrupo: Number(fichaGrupo),
      anioLectivo: Number(anioLectivo),
      coddaneEnteconformador: Number(coddaneEnteconformador),
      detallesMatricula: detallesMatricula.map((detalle) => ({
        documentoAprendiz: Number(detalle.documentoAprendiz),
        estadoMatricula: detalle.estadoMatricula,
        tipoMatricula: detalle.tipoMatricula,
        fichaGrupo: Number(fichaGrupo),
      })),
    };

    try {
      const response = await axios.post('/api/matriculas/add', newMatricula);

      await Swal.fire({
        icon: 'success',
        title: 'Matrícula registrada con éxito',
        text: response.data.message,
        showConfirmButton: false,
        timer: 2000,
      });

      navigate('/matricula/listarmatriculas'); // Navegar después del guardado exitoso

      cleanData(); // Limpia los campos después de una respuesta exitosa
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Error al enviar los datos',
      });
    }
  };

  //----------------------------------------------------------------------------------------------

  const updateMatricula = async () => {
    if (!anioLectivo || !coddaneEnteconformador || detallesMatricula.length === 0) {
      return Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Por favor completa todos los campos y agrega al menos un aprendiz.',
      });
    }

    const updatedMatricula = {
      fichaGrupo: Number(fichaGrupo), // 👈 ESTE FALTABA
      anioLectivo: Number(anioLectivo),
      coddaneEnteconformador: Number(coddaneEnteconformador),
      detallesMatricula: detallesMatricula.map((detalle) => ({
        documentoAprendiz: Number(detalle.documentoAprendiz),
        estadoMatricula: detalle.estadoMatricula,
        tipoMatricula: detalle.tipoMatricula,
        fichaGrupo: Number(fichaGrupo),
      })),
    };


    try {
      const response = await axios.put(`/api/matriculas/update/${id}`, updatedMatricula);

      await Swal.fire({
        icon: 'success',
        title: 'Matrícula actualizada con éxito',
        text: response.data.message,
        showConfirmButton: false,
        timer: 2000,
      });

      navigate('/matricula/listarmatriculas');
      cleanData();
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Error al actualizar la matrícula',
      });
    }
  };


  const actions = (e) => {
    e.preventDefault();
    edit ? updateMatricula() : saveMatricula();
  };

  //-----------------------------Cargar y Seleccionar los Grupos o Fichas ------------------------------------------------------------------
  useEffect(() => {
    const cargarGrupos = async () => {
      const gruposData = await senaFunciones.obtenerGrupos();
      setGrupos(gruposData);
    };

    cargarGrupos();
  }, []);

  const handleGruposChange = (e) => {
    const selectedFichaGrupo = e.target.value;
    setGrupoSeleccionado(selectedFichaGrupo);
    setFichaGrupo(selectedFichaGrupo);
  };

  //-----------------------------Cargar y Seleccionar los Entes o Instituciones Educativas --------------------------------------------------
  useEffect(() => {
    const cargarEntes = async () => {
      const enteData = await enteFunciones.obtenerEntesConformadores();
      setEntes(enteData);
    };

    cargarEntes();
  }, []);


  //--------------------------------------------------------------------------------------------------

  const verificarDocumentoAprendiz = async (documento, index) => {
    if (!documento) return;

    try {
      const response = await axios.get(`/api/aprendices/verificar/${documento}`);

      if (response.data.exists) {
        handleChange(index, 'nombreAprendiz', response.data.nombreCompleto);
      } else {
        handleChange(index, 'nombreAprendiz', '');
      }
    } catch (error) {
      console.error('Error al verificar el documento del aprendiz:', error);
      handleChange(index, 'nombreAprendiz', '');
    }
  };

  const handleDocumentoAprendizChange = (e, index) => {
    const documento = e.target.value;
    handleChange(index, 'documentoAprendiz', documento);
  };

  const handleDocumentoAprendizKeyDown = (e, index) => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      verificarDocumentoAprendiz(e.target.value, index);
    }
  };

  const handleDocumentoAprendizBlur = (e, index) => {
    verificarDocumentoAprendiz(e.target.value, index);
  };



  return (
    <div>
      <form onSubmit={actions}>

        <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
          < div className='container-fluid mt-3' >
            <h1>Registrar Matrícula</h1>
          </div>

          <div className="container mb-5">
            <div className="row d-flex justify-content-between">

              {/* Año Lectivo */}
              <div className="col-md-3">
                <label htmlFor="anioLectivo" className="form-label mb-2">Año Lectivo</label>
                <select
                  className="form-control"
                  id="anioLectivo"
                  value={anioLectivo}
                  onChange={(e) => setAnioLectivo(e.target.value)}
                  required
                >
                  <option value="">Seleccione el Año</option>
                  {Array.from({ length: new Date().getFullYear() - 2015 + 1 }, (_, index) => {
                    const year = 2015 + index;
                    return (
                      <option key={year} value={year}>{year}</option>
                    );
                  })}
                </select>
              </div>

              {/* Grupos */}
              <div className="col-md-3">
                <label htmlFor="grupos" className="form-label mb-2">Grupos</label>
                <Select
                  id="grupos"
                  options={opcionesGrupos}
                  value={grupoSeleccionado ? opcionesGrupos.find(op => op.value === grupoSeleccionado) : null}
                  onChange={(opcion) => handleGruposChange({ target: { value: opcion.value } })}
                  placeholder="Seleccione un grupo"
                  isSearchable
                />
              </div>

              {/* Entes */}
              <div className="col-md-4">
                <label htmlFor="entes" className="form-label mb-2">Entes</label>
                <Select
                  id="entes"
                  options={opcionesEntes}
                  value={coddaneEnteconformador ? opcionesEntes.find(op => op.value === coddaneEnteconformador) : null}
                  onChange={(opcion) => setCoddaneEnteconformador(opcion.value)}
                  placeholder="Seleccione un ente..."
                  isSearchable
                />
              </div>
            </div>
          </div>
        </div>

        {/* Con estos campos logre validar el funcionamiento de los input y la carga de la información
              <input
                type="number"
                placeholder="Ficha Grupo"
                value={fichaGrupo}
                onChange={(e) => setFichaGrupo(e.target.value)}
                required />

              <input
                type="number"
                placeholder="Año Lectivo"
                value={anioLectivo}
                onChange={(e) => setAnioLectivo(e.target.value)}
                required />


              <input
                type="number"
                placeholder="CodDane Ente Conformador"
                value={coddaneEnteconformador}
                onChange={(e) => setCoddaneEnteconformador(e.target.value)}
                required />

                */}

        {/* Gestión de Aprendices */}


        <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
          < div className='container-fluid mt-3' >
            <h1>Gestión de Matriculados</h1>
          </div>

          <div className="container mb-5">

            {/* Encabezados solo en pantallas medianas o más grandes */}
            <div className="row text-center mb-2 d-none d-md-flex">
              <div className="col-md-3">Documento</div>
              <div className="col-md-4">Nombre</div>
              <div className="col-md-2">Estado Matrícula</div>
              <div className="col-md-2">Tipo Matrícula</div>
              <div className="col-md-1"></div>
            </div>

            {detallesMatricula.map((detalle, index) => (
              <div key={index} className="row align-items-center mb-3 gy-2">
                {/* Documento */}
                <div className="col-12 col-md-3">
                  <label className="form-label d-md-none">Documento</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Documento Aprendiz"
                    value={detalle.documentoAprendiz}
                    onChange={(e) => handleDocumentoAprendizChange(e, index)}
                    onKeyDown={(e) => handleDocumentoAprendizKeyDown(e, index)}
                    onBlur={(e) => handleDocumentoAprendizBlur(e, index)}
                    required
                  />
                </div>

                {/* Nombre */}
                <div className="col-12 col-md-4">
                  <label className="form-label d-md-none">Nombre</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nombre Aprendiz"
                    value={detalle.nombreAprendiz || ''}
                    readOnly
                    disabled
                  />
                </div>

                {/* Estado Matrícula */}
                <div className="col-12 col-md-2">
                  <label className="form-label d-md-none">Estado Matrícula</label>
                  <select
                    value={detalle.estadoMatricula}
                    className="form-select"
                    onChange={(e) => handleChange(index, 'estadoMatricula', e.target.value)}
                    required
                  >
                    <option value="">Seleccione estado</option>
                    <option value="Matriculado">Matriculado</option>
                    <option value="Pendiente">Pendiente</option>
                  </select>
                </div>

                {/* Tipo Matrícula */}
                <div className="col-12 col-md-2">
                  <label className="form-label d-md-none">Tipo Matrícula</label>
                  <select
                    value={detalle.tipoMatricula}
                    className="form-select"
                    onChange={(e) => handleChange(index, 'tipoMatricula', e.target.value)}
                    required
                  >
                    <option value="">Seleccione tipo</option>
                    <option value="Ordinaria">Ordinaria</option>
                    <option value="Extraordinaria">Extraordinaria</option>
                  </select>
                </div>

                {/* Botón eliminar */}
                <div className="col-12 col-md-1 text-end mt-2 mt-md-0">
                  <button
                    type="button"
                    className="btn btn-danger p-0"
                    style={{ width: 30, height: 30 }}
                    onClick={() => removeDetalle(index)}
                    title="Eliminar Aprendiz"
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Botón de Envío */}
          <div className="container col-12 mt-4 mb-5">
            <div className="row g-3">
              <div className="col-12 col-md-4">
                <button type="button" className="btn btn-primary w-100 d-flex  justify-content-center"
                  style={{ height: "100%" }} onClick={addDetalle}> Agregar Aprendiz </button>
              </div>
              <div className="col-12 col-md-4">
                <button type="submit" className="btn btn-success w-100 d-flex  justify-content-center"
                  style={{ height: "100%" }}> {id ? 'Actualizar' : 'Enviar'} </button>
              </div>

              <div className="col-12 col-md-4">
                <button type="button" className="btn btn-danger w-100 d-flex justify-content-center"
                  style={{ height: "100%" }} onClick={() => {
                    if (location.pathname === '/matricula/registrar') {
                      cleanData();
                    } else { navigate('/matricula/listarmatriculas'); }
                  }} > Cancelar </button>
              </div>
            </div>
          </div>

        </div>

      </form>


    </div>
  );
};

export default RegistrarMatriculas;
